<template>
    <div class="home">
        <router-link
            v-for="(schedule, index) in schedules"
            :key="index"
            :to="schedule.path"
        >
            <v-card
                class="mx-auto"
                :color="schedule.color"
                dark
                max-width="400"
            >
                <v-card-title>
                    <v-icon medium left v-text="schedule.icon"></v-icon>
                    <span
                        class="title font-weight-light"
                        v-text="schedule.name"
                    ></span>
                </v-card-title>
            </v-card>
        </router-link>
    </div>
</template>

<script>
export default {
    name: "Home",
    props: ["schedules"]
};
</script>

<style scoped>
div.v-card {
    padding: 0 5px;
    margin: 10px;
    text-align: center;
}
div.v-card i.v-icon {
    margin-right: 15px;
}
</style>
